function custodianTitles(pathname) {
  if (pathname === '/custodian') {
    return {
      title: 'Custodian — Dashboard',
      subtitle:
        'Packages awaiting Custodian legal authority — review, admit, and custody execution.',
    };
  }
  if (pathname.startsWith('/custodian/awaiting-review')) {
    return {
      title: 'Custodian — Awaiting review',
      subtitle:
        'Authority-ready packaged candidates — evidence completeness, provider recommendation, and admission decision.',
    };
  }
  if (pathname.startsWith('/custodian/explorer')) {
    return {
      title: 'Custodian — Custody explorer',
      subtitle:
        'Drill path by facility / trust / SPV before individual asset.',
    };
  }
  if (pathname.match(/^\/custodian\/assets\/[^/]+$/)) {
    return {
      title: 'Custodian — Asset register',
      subtitle:
        'Certification and custody detail for a selected asset.',
    };
  }
  if (pathname.startsWith('/custodian/assets')) {
    return {
      title: 'Custodian — Asset register',
      subtitle: 'Master register of all assets under custody.',
    };
  }
  if (pathname.startsWith('/custodian/pledges')) {
    return {
      title: 'Custodian — Pledge queue',
      subtitle:
        'Prerequisites, materials, execution, and pledge receipt issuance.',
    };
  }
  if (pathname.startsWith('/custodian/release-copy')) {
    return {
      title: 'Custodian — Release & copy',
      subtitle:
        'Queue for discharge, release completion, and certified copies.',
    };
  }
  if (pathname.startsWith('/custodian/transfers')) {
    return {
      title: 'Custodian — Transfer queue',
      subtitle:
        'From/to parties, acknowledgements, and conflicts with pledge or release.',
    };
  }
  if (pathname.match(/^\/custodian\/exceptions\/[^/]+$/)) {
    return {
      title: 'Custodian — Exception detail',
      subtitle: 'Custody-side blockers and remediation.',
    };
  }
  if (pathname.startsWith('/custodian/exceptions')) {
    return {
      title: 'Custodian — Exceptions',
      subtitle: 'Clarification blockers and state mismatches.',
    };
  }
  if (pathname === '/custodian/evidence') {
    return {
      title: 'Custodian — Evidence & certificates',
      subtitle: 'Receipts, copies, bundles, and certificate history.',
    };
  }
  if (pathname.startsWith('/custodian/evidence/receipts')) {
    return {
      title: 'Custodian — Custody receipts',
      subtitle: 'Issue, reissue, resend, and track admission and event receipts.',
    };
  }
  if (pathname.startsWith('/custodian/evidence/certified-copies')) {
    return {
      title: 'Custodian — Certified copy outputs',
      subtitle: 'Package state, watermark, requester, and delivery.',
    };
  }
  if (pathname.startsWith('/custodian/evidence/bundles')) {
    return {
      title: 'Custodian — Evidence bundles',
      subtitle: 'Manifest hash, validation, export, and lifecycle artifacts.',
    };
  }
  if (pathname.startsWith('/custodian/evidence/certificate-history')) {
    return {
      title: 'Custodian — Certificate history',
      subtitle: 'Active, superseded, archived, and supersession chains.',
    };
  }
  if (pathname.startsWith('/custodian/search')) {
    return {
      title: 'Custodian — Search & ask',
      subtitle:
        'Grounded search and Q&A over assets, evidence, receipts, and custody actions.',
    };
  }
  if (pathname === '/custodian/reports/inventory') {
    return {
      title: 'Custodian — Reports',
      subtitle:
        'Custody Inventory Dashboard — state and inventory across facilities and asset populations.',
    };
  }
  if (pathname === '/custodian/reports/movement') {
    return {
      title: 'Custodian — Reports',
      subtitle: 'Custody Movement Dashboard — lifecycle actions and execution outcomes.',
    };
  }
  if (pathname === '/custodian/reports/certification-receipts') {
    return {
      title: 'Custodian — Reports',
      subtitle:
        'Certification & Receipts Dashboard — KPIs, recent certificate activity, and delivery posture.',
    };
  }
  if (pathname === '/custodian/reports/turnaround-sla') {
    return {
      title: 'Custodian — Reports',
      subtitle:
        'Turnaround & SLA Dashboard — median times by queue, aging, and longest open items.',
    };
  }
  if (pathname.startsWith('/custodian/reports')) {
    return {
      title: 'Custodian — Reports center',
      subtitle: 'Tiles navigate only; run, schedule, and export in each dashboard.',
    };
  }
  if (pathname.startsWith('/custodian/settings')) {
    return {
      title: 'Custodian — Settings',
      subtitle: 'Internal routing, entitlements, and notifications.',
    };
  }
  return { title: 'Custodian', subtitle: null };
}

function providerTitles(pathname) {
  if (pathname === '/provider') {
    return {
      title: 'Provider workspace — Dashboard',
      subtitle:
        'Inbound volume, authority gating, custody handoff, and integration health — control plane, not submission home.',
    };
  }
  if (pathname === '/provider/intake/programs') {
    return {
      title: 'eVault Provider workspace — Intake explorer',
      subtitle:
        'Submitter / program view to spot trends, backlog, and issue concentration.',
    };
  }
  if (pathname.startsWith('/provider/intake')) {
    return {
      title: 'eVault Provider workspace — Intake explorer',
      subtitle:
        'Batch-first operational view across every submitter and source.',
    };
  }
  if (pathname.match(/^\/provider\/authority-review\/[^/]+$/)) {
    return {
      title: 'Provider workspace — Candidate review',
      subtitle:
        'Eligibility review: candidate for Custodian, repository only, return, or block. Not Custodian legal authority.',
    };
  }
  if (pathname.startsWith('/provider/authority-review')) {
    return {
      title: 'eVault Provider workspace — Authority review',
      subtitle:
        'Provider eligibility queue for certified packages. CANDIDATE is a recommendation, not legal authority.',
    };
  }
  if (pathname.match(/^\/provider\/packages\/[^/]+$/)) {
    return {
      title: 'Provider workspace — Package detail',
      subtitle:
        'Provider truth screen: validation, classification, ownership, evidence readiness, and next action.',
    };
  }
  if (pathname.startsWith('/provider/packages')) {
    return {
      title: 'Provider workspace — Packages',
      subtitle:
        'Deep package inspection across validation, extraction, evidence, and owner queues.',
    };
  }
  if (pathname.match(/^\/provider\/assets\/[^/]+$/)) {
    return {
      title: 'Digitize',
      subtitle:
        'Review extracted fields and validation against the uploaded source document.',
    };
  }
  if (pathname.startsWith('/provider/assets')) {
    return {
      title: 'Digitize',
      subtitle: 'Choose a loan to review documents, extracted fields, and validation.',
    };
  }
  if (pathname.startsWith('/provider/custody-packaging')) {
    return {
      title: 'eVault Provider workspace — Custody packaging',
      subtitle:
        'Provider-side packaging and handoff before the custodian acts.',
    };
  }
  if (pathname.match(/^\/provider\/exceptions\/[^/]+$/)) {
    return {
      title: 'Provider workspace — Exception detail',
      subtitle:
        'Blocking issues, technical rejects, duplicates, and unresolved review states.',
    };
  }
  if (pathname.startsWith('/provider/exceptions')) {
    return {
      title: 'Provider workspace — Exceptions',
      subtitle:
        'Issues that block packaging, authority decisions, or custodian handoff.',
    };
  }
  if (pathname.startsWith('/provider/search')) {
    return {
      title: 'eVault Provider workspace — Search & Ask',
      subtitle:
        'Grounded search across packages, assets, evidence bundles, and custody events.',
    };
  }
  if (pathname === '/provider/reports/intake-throughput') {
    return {
      title: 'Provider workspace — Intake throughput dashboard',
      subtitle: 'Volume, latency, queue aging, and source concentration.',
    };
  }
  if (pathname === '/provider/reports/authority-outcomes') {
    return {
      title: 'Provider workspace — Authority outcomes dashboard',
      subtitle:
        'Candidate, repository-only, duplicate-block, and admit (custodian-routed) outcomes.',
    };
  }
  if (pathname === '/provider/reports/custody-handoff') {
    return {
      title: 'eVault Provider workspace — Reports',
      subtitle:
        'Custody packaging & handoff — actions ready for the custodian, delayed, executed, and rejected or returned.',
    };
  }
  if (pathname === '/provider/reports/integration-health') {
    return {
      title: 'eVault Provider workspace — Reports',
      subtitle:
        'Integration health — API, webhook, SFTP, and partner feed reliability, retries, and latency.',
    };
  }
  if (pathname === '/provider/reports') {
    return {
      title: 'Provider workspace — Reports center',
      subtitle:
        'Tiles navigate only; run, schedule, and export live inside each dashboard.',
    };
  }
  if (pathname.startsWith('/provider/programs-rules')) {
    return {
      title: 'eVault Provider workspace — Programs & Rules',
      subtitle:
        'Configure the Programme Admission Profile used for subsequent submissions.',
    };
  }
  if (pathname.startsWith('/provider/integrations')) {
    return {
      title: 'eVault Provider workspace — Integrations',
      subtitle:
        'Connector administration, webhook diagnostics, and credential health.',
    };
  }
  if (pathname.startsWith('/provider/audit-settings')) {
    return {
      title: 'Provider workspace — Audit & settings',
      subtitle: 'Access, policy history, system notices, and admin controls.',
    };
  }
  if (pathname === '/provider/admin/organizations/new') {
    return {
      title: 'Provider Admin — Add organization',
      subtitle: 'Stage 0 — create the institution before people, connections, or Digitize.',
    };
  }
  if (pathname.match(/^\/provider\/admin\/organizations\/[^/]+$/)) {
    return {
      title: 'Provider Admin — Organization setup',
      subtitle: 'Profile and status first; people and Digitize stay behind this org.',
    };
  }
  if (pathname.startsWith('/provider/admin/organizations')) {
    return {
      title: 'Provider Admin — Organizations',
      subtitle: 'Configuration control starts here. Add an organization before anything else.',
    };
  }
  if (pathname === '/provider/admin/programs/new') {
    return {
      title: 'Provider Admin — Add program',
      subtitle: "Create a program on an originator organization in this provider's scope.",
    };
  }
  if (pathname.startsWith('/provider/admin/programs')) {
    return {
      title: 'Provider Admin — Programs',
      subtitle: "Programs owned by originators in this provider's scope.",
    };
  }
  if (pathname.startsWith('/provider/admin/people')) {
    return {
      title: 'Provider Admin — People',
      subtitle: 'Members across your Provider org and connected institutions.',
    };
  }
  if (pathname.startsWith('/provider/admin/roles')) {
    return {
      title: 'Provider Admin — Roles',
      subtitle: 'System role catalog by organization type.',
    };
  }
  if (pathname.startsWith('/provider/admin/connections')) {
    return {
      title: 'Provider Admin — Connections',
      subtitle: 'Originator ↔ Provider ↔ Custodian routing edges.',
    };
  }
  if (pathname.startsWith('/provider/admin/digitize')) {
    return {
      title: 'Provider Admin — Digitize bindings',
      subtitle: 'Bind an existing Originator to a VA e_id / q_id. Catalog stays in VA.',
    };
  }
  if (pathname.startsWith('/provider/admin/audit')) {
    return {
      title: 'Provider Admin — Audit',
      subtitle: 'Admin mutations in this Provider scope.',
    };
  }
  return { title: 'Provider workspace', subtitle: null };
}

function investorTitles(pathname) {
  if (pathname === '/investor') {
    return {
      title: 'Investor workspace — Overview',
      subtitle: 'Platform-wide, read-only: every organisation, package, transaction and audit entry.',
    };
  }
  if (pathname === '/investor/packages') {
    return {
      title: 'Investor workspace — Packages',
      subtitle: 'Every package across all originators and custodians.',
    };
  }
  if (pathname.startsWith('/investor/packages/')) {
    return {
      title: 'Investor workspace — Package',
      subtitle: 'Assets, files, exceptions and the full timeline of who did what, when.',
    };
  }
  if (pathname === '/investor/activity') {
    return {
      title: 'Investor workspace — Activity',
      subtitle: 'Every recorded transaction on the platform, newest first.',
    };
  }
  if (pathname === '/investor/audit') {
    return {
      title: 'Investor workspace — Admin audit',
      subtitle: 'Administrative actions: organisations, people, connections, bindings.',
    };
  }
  if (pathname === '/investor/organizations') {
    return { title: 'Investor workspace — Organizations', subtitle: null };
  }
  if (pathname === '/investor/programs') {
    return { title: 'Investor workspace — Programs', subtitle: null };
  }
  return { title: 'Investor workspace', subtitle: null };
}

export function titleForPath(pathname) {
  if (pathname.startsWith('/investor')) {
    return investorTitles(pathname);
  }
  if (pathname.startsWith('/custodian')) {
    return custodianTitles(pathname);
  }
  if (pathname.startsWith('/provider')) {
    return providerTitles(pathname);
  }
  if (pathname === '/') {
    return { title: 'Originator workspace — Dashboard', subtitle: null };
  }
  if (pathname.startsWith('/submission')) {
    return {
      title: 'Originator workspace — New submission',
      subtitle:
        'Program context, package upload, data tape, and validation handoff.',
    };
  }
  if (pathname.match(/^\/packages\/[^/]+\/assets\/[^/]+$/)) {
    return {
      title: 'Digitize',
      subtitle:
        'View the uploaded source document and any extracted fields or validation for this loan.',
    };
  }
  if (pathname.match(/^\/packages\/[^/]+$/)) {
    return {
      title: 'Originator workspace — Package detail',
      subtitle:
        'Package detail with document-level statuses, evidence readiness, and custody handoff.',
    };
  }
  if (pathname.startsWith('/packages')) {
    return {
      title: 'Originator workspace — Packages',
      subtitle:
        'Track packages from pre-validation through custody review and admission.',
    };
  }
  if (pathname.match(/^\/exceptions\/[^/]+$/)) {
    return {
      title: 'Originator workspace — Exception detail',
      subtitle: 'Remediation workspace with source preview and cure actions.',
    };
  }
  if (pathname.startsWith('/exceptions')) {
    return {
      title: 'Originator workspace — Exceptions',
      subtitle:
        'Everything that needs originator action before custody can proceed.',
    };
  }
  if (pathname.match(/^\/loans\/[^/]+$/)) {
    return {
      title: 'Loan / asset detail',
      subtitle: 'Custody status, facility exposure, and servicing context.',
    };
  }
  if (pathname.startsWith('/loans')) {
    return {
      title: 'Originator workspace — Loans / assets',
      subtitle:
        'Batch → Deal / facility / SPV → Loan → Loan detail. Start in Portfolio Explorer; open a loan only after the right business context.',
    };
  }
  if (pathname.startsWith('/requests')) {
    return {
      title: 'Requests',
      subtitle: 'Originator requests routed to the custodian for action.',
    };
  }
  if (pathname.startsWith('/search')) {
    return {
      title: 'Search & ask',
      subtitle: 'Search packages, admitted assets, evidence, and documents.',
    };
  }
  if (pathname === '/reports/boarding') {
    return {
      title: 'Originator workspace — Boarding summary',
      subtitle:
        'Track submission throughput, package health, and cure SLAs.',
    };
  }
  if (pathname === '/reports/authority') {
    return {
      title: 'Originator workspace — Authority outcomes',
      subtitle:
        'Authority funnel — admitted, repository-only, rejected, and custodian pending.',
    };
  }
  if (pathname === '/reports/custody') {
    return {
      title: 'Originator workspace — Custody / facility status',
      subtitle: 'Vault, pledged, release pending, and facility-tied positions.',
    };
  }
  if (pathname === '/reports/spv-servicing') {
    return {
      title: 'Originator workspace — SPV / sold with servicing',
      subtitle: 'Retained visibility where servicing is retained post-sale.',
    };
  }
  if (pathname === '/reports/evidence') {
    return {
      title: 'Originator workspace — Evidence & export history',
      subtitle: 'Bundles, receipts, certified copies, and report exports.',
    };
  }
  if (pathname.startsWith('/reports')) {
    return {
      title: 'Originator workspace — Reports',
      subtitle:
        'Operational report modules — tiles open dedicated dashboards.',
    };
  }
  return { title: 'UMB eVault', subtitle: null };
}

